import {useContext} from 'react';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import { Context } from '../../../index';
import { observer } from 'mobx-react-lite';
import { Route, Routes, NavLink, Navigate } from 'react-router-dom';

import Information from './Information/Information'
import Cart from './Cart/ProfileCart'
import Transactions from './Transactions/ProfileTransactions'
import Transfers from './Transfers/Transfers'
import Promocodes from './Promocodes/Promocodes'

import './profile.css'
import Unauthorized from '../../Unauthorized/Unauthorized';
import SpinnerLoader from '../../Loaders/SpinnerLoader';

const Body = () => {
    const {store} = useContext(Context);

    const { i18n } = useTranslation();
    const languages = i18n.languages;
    const langBtn = (languages.includes('en')) ? "_lang__en": "";
    
    return(
        <main>
            {store.isLoaded ?
                <div className="xbox__body profile__table">
                    {
                    store.isAuth ?
                    <>
                    <div className="xbox__div-1 profile">
                        <nav className="profile__choosePage">
                            <NavLink to='' end className={`nav-item-2 ${langBtn}`}>{t('profile.information')}</NavLink>
                            <NavLink to='storage' className={`nav-item-2 ${langBtn}`}>{t('profile.store.title')}</NavLink>
                            <NavLink to='transactions' className={`nav-item-2 ${langBtn}`}>{t('profile.transactions.title')}</NavLink>
                            <NavLink to='transfer' className={`nav-item-2 ${langBtn}`}>{t('profile.transfer.title')}</NavLink>
                            <NavLink to='promocode' className={`nav-item-2 ${langBtn}`}>{t('profile.promocode.title')}</NavLink>
                            <button className={`nav-item-2 _logout__button ${langBtn}`} onClick={() => store.logout()}>{t('profile.logout')}</button>
                        </nav>
                        <Routes>
                            <Route path="*" element={<Navigate to="" />} />
                            <Route path="/" element={<Information user={store.user}/>} />
                            <Route path="storage" element={<Cart />} />
                            <Route path="transactions" element={<Transactions />} />
                            <Route path="transfer" element={<Transfers />} /> <Route path="transfers" element={<Navigate to="../transfer" />} />
                            <Route path="promocode" element={<Promocodes />} /> <Route path="promocodes" element={<Navigate to="../promocode" />} />
                        </Routes>
                    </div>
                    </>:
                    <Unauthorized />
                    }
                </div>
                :
                < SpinnerLoader />
            }
        </main>
    )
}

export default observer(Body);